import { mdiPackageVariantClosed } from '@mdi/js'

export default {
  title: 'Packet',
  to: 'packet-list',
  icon: mdiPackageVariantClosed,
  action: 'read',
  resource: 'PacketAdmin',
}
